import {
  Box,
  Button,
  Circle,
  CircularProgress,
  CircularProgressLabel,
  FormControl,
  FormLabel,
  Heading,
  HStack,
  Image,
  ImageProps,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  NumberInput,
  NumberInputField,
  Popover,
  PopoverArrow,
  PopoverContent,
  PopoverTrigger,
  Spinner,
  Stack,
  Text,
  useBreakpointValue,
  useDisclosure,
  useToast,
  VStack,
} from "@chakra-ui/react";
import { bookmarkIcon, circlePlayIcon, editIcom } from "assets/images";
import { CustomHeader, TouchableOpacity } from "components";
import { getSession } from "features/auth/slice";
import { useTranslation } from "languages";
import React, { ReactNode, useState } from "react";
import ReactPlayer from "react-player";
import { useAppDispatch, useAppSelector } from "tools/store";
import { createAyahNumber, removeBismillah, ShowToast } from "utils/Helpers";
import { getFontSize } from "../global_slice";
import {
  getCurrentPage,
  getSelectedItem,
  setCurrentPage,
  setSelected,
} from "../non_persist_slice";
import {
  useAddBookmarkMutation,
  useAddNoteMutation,
  useGetBookmarksQuery,
  useGetNotesQuery,
} from "../service";
import {
  useGetQuranPagesQuery,
  useLazyGetSingleAyahQuery,
} from "../service_external";

const Dashboard: React.FC = () => {
  const TOTAL_PAGES = 604;
  const currentPage = useAppSelector(getCurrentPage);
  const userData = useAppSelector(getSession);
  const translation = useTranslation();
  const toast = useToast();

  const layoutDirection = useBreakpointValue({ base: "column", md: "row" });

  const { data: bookmarkData, isLoading: isBookmarkLoad } =
    useGetBookmarksQuery(userData?.user?.id || 0, {
      skip: !userData?.user?.id,
    });
  const { data: notesData } = useGetNotesQuery(userData?.user?.id || 0, {
    skip: !userData?.user?.id,
  });

  const [addBookmark, { isLoading: isCreatingBookmarks }] =
    useAddBookmarkMutation();
  const [addNotes, { isLoading: isCreatingNotes }] = useAddNoteMutation();

  const dispatch = useAppDispatch();

  const [audioUrl, setAudioUrl] = useState<string>("");
  const [isBuffering, setIsBuffering] = useState<boolean>(false);
  const selectedItem = useAppSelector(getSelectedItem);

  const dynamicFontSize = useAppSelector(getFontSize);

  const { data, isFetching } = useGetQuranPagesQuery(currentPage);
  const [getSingleAyah, { isFetching: ayahLoad }] = useLazyGetSingleAyahQuery();

  const handlePlay = (ayahNumber: number) => {
    getSingleAyah(ayahNumber)
      .then((res) => {
        if (res.data && !res.error) {
          setAudioUrl(res?.data?.data?.audio);
        }
      })
      .catch((e) => console.log("=-=-=error:", e));
    dispatch(setSelected({}));
  };

  const handleAddBookmark = (item: any) => {
    const bookmarkList =
      bookmarkData && bookmarkData?.length > 0
        ? bookmarkData.map((it: any) => ({
            ...it,
            content: JSON.parse(it?.content),
          }))
        : [];

    const date = new Date();
    const findInd = (bookmarkList || [])?.findIndex(
      (it: any) => it?.content?.number === item?.number
    );

    if (findInd === -1) {
      var payload = {
        user_id: userData?.user.id,
        content: JSON.stringify({ ...item, date }),
      };
      addBookmark(payload)
        .then((res) => {
          if (res.data && !res.error) {
            ShowToast(toast, translation["bookSave"], "success");
          }
        })
        .catch(console.error);
    } else {
      ShowToast(toast, translation["alreadyBook"], "warning");
    }
  };

  const handleAddNote = (item: any) => {
    const list =
      notesData && notesData?.length > 0
        ? notesData.map((it: any) => ({
            ...it,
            content: JSON.parse(it?.content),
          }))
        : [];

    const date = new Date();
    const findInd = (list || [])?.findIndex(
      (it: any) => it?.content?.number === item?.number
    );

    if (findInd === -1) {
      var payload = {
        user_id: userData?.user.id,
        content: JSON.stringify({ ...item, date }),
      };
      addNotes(payload)
        .then((res) => {
          if (res.data && !res.error) {
            ShowToast(toast, translation["notsSave"], "success");
          }
        })
        .catch(console.error);
    } else {
      ShowToast(toast, translation["alreadySaved"], "warning");
      // tempList.splice(findInd, 1, { ...item, date });
    }
  };

  const handleNext = () => {
    const temp = currentPage + 1;
    dispatch(setCurrentPage(temp));
  };
  const handlePrevious = () => {
    const temp = currentPage - 1;
    dispatch(setCurrentPage(temp));
  };

  const bismillah1 = "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ";
  const bismillah2 = "بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ";
  const bismillah3 = "بِّسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ";

  const rennderItem = (ayahItem: any, ayahIndex: number) => {
    return (
      <Popover
        isOpen={
          selectedItem !== null && ayahItem?.number === selectedItem?.number
        }
        onClose={() => dispatch(setSelected({}))}
        key={ayahIndex}
      >
        {({ onClose }) => (
          <>
            <PopoverTrigger>
              <Text
                display={"inline"}
                _hover={{ color: "primary.300" }}
                bgColor={
                  selectedItem?.number === ayahItem?.number
                    ? "primary.40"
                    : undefined
                }
                onClick={() => dispatch(setSelected(ayahItem))}
              >
                {currentPage === 1
                  ? ayahItem?.text
                  : removeBismillah(ayahItem?.text)}
                <CircularProgress
                  value={100}
                  color="primary.300"
                  mx={3}
                  thickness="4px"
                  size={`${dynamicFontSize * 1.2}px`}
                  // size={[
                  //   `${dynamicFontSize * 0.8}px`,
                  //   `${dynamicFontSize * 1}px`,
                  //   `${dynamicFontSize * 1.2}px`,
                  // ]}
                >
                  <CircularProgressLabel>
                    {createAyahNumber(ayahItem?.numberInSurah)}
                  </CircularProgressLabel>
                </CircularProgress>
              </Text>
            </PopoverTrigger>
            <PopoverContent
              borderWidth={0}
              bgGradient="linear(to-tl, secondary.50, secondary.200, secondary.50)"
              flexDirection={"row"}
              justifyContent={"space-between"}
              // padding={3}
              padding={[2, 3]}
              borderRadius={15}
            >
              <PopoverArrow bgColor={"secondary.50"} />

              <ClickableImage
                src={bookmarkIcon}
                onClick={() => {
                  if (!userData?.user) {
                    ShowToast(toast, translation["loginRequire"], "warning");
                    onClose();
                    return;
                  }
                  handleAddBookmark(ayahItem);
                  onClose();
                }}
              />

              {userData?.user ? (
                <NotesModal
                  trigger={<ClickableImage src={editIcom} />}
                  onSave={(val) => {
                    if (val === "") {
                      ShowToast(toast, translation["notsReq"], "warning");
                      onClose();
                      return;
                    }
                    handleAddNote({ ...ayahItem, note: val });
                    onClose();
                  }}
                />
              ) : (
                <ClickableImage
                  src={editIcom}
                  onClick={() => {
                    if (!userData?.user) {
                      ShowToast(toast, translation["loginRequire"], "warning");
                      onClose();
                      return;
                    }
                  }}
                />
              )}

              <ClickableImage
                src={circlePlayIcon}
                onClick={() => {
                  handlePlay(ayahItem?.number);
                  onClose();
                }}
              />
            </PopoverContent>
          </>
        )}
      </Popover>
    );
  };

  // if (isFetching || isBookmarkLoad || isCreatingBookmarks || isCreatingNotes) {
  //   return <Spinner size="xl" position={"absolute"} top={"50%"} left={"50%"} />;
  // }

  return (
    <Stack pb={[4, 6, 10]} px={[4, 6, 10]} h={"full"}>
      {(isFetching ||
        isBookmarkLoad ||
        isCreatingBookmarks ||
        isCreatingNotes) && (
        <Spinner size="xl" position={"absolute"} top={"50%"} left={"50%"} />
      )}

      <CustomHeader />

      <Stack alignSelf={"center"} h={"calc(100% - 70px)"}>
        <VStack
          overflow={"auto"}
          style={{ scrollbarWidth: "none" }}
          h="calc(100% - 40px)"
          gap={[3, 4, 5]}
        >
          {(data || []).map((item: any, index: number) => (
            <Stack key={index} gap={[3, 4, 5]} w="full">
              <HStack
                h={"65px"}
                w="full"
                border={"2px solid var(--chakra-colors-primary-300)"}
                justify={"space-between"}
                px={[4, 6]}
                // paddingInline={8}
                borderRadius={"xl"}
                color={"white"}
                fontWeight={"extrabold"}
                fontSize={["md", "lg", "xl"]}
              >
                <Circle
                  bgColor={"primary.100"}
                  size={["20px", "30px"]}
                  color={"primary.300"}
                >
                  <Text fontSize={["sm", "md"]}>
                    {createAyahNumber(item.number)}
                  </Text>
                </Circle>

                {(item?.ayahs[0]?.text.includes(bismillah1) ||
                  item?.ayahs[0]?.text.includes(bismillah2) ||
                  item?.ayahs[0]?.text.includes(bismillah3)) && (
                  <Text
                    fontSize={["lg", "xl", "2xl", "3xl"]}
                    color={"primary.300"}
                  >
                    {bismillah1}
                  </Text>
                )}

                <Text fontSize={["sm", "md", "lg"]}>{item.name}</Text>
              </HStack>

              <Text
                style={{
                  direction: "rtl",
                  textAlign: "justify",
                  MozTextAlignLast: "center",
                  textAlignLast: "center",
                }}
                color={"white"}
                letterSpacing={layoutDirection === "row" ? 2 : undefined}
                fontSize={dynamicFontSize || "5xl"}
                // fontSize={["xl", "2xl", dynamicFontSize || "5xl"]}
              >
                {(item?.ayahs || []).map(rennderItem)}
              </Text>
            </Stack>
          ))}
        </VStack>

        <HStack
          h={"40px"}
          // px={[4, 6, 10]}
          w={"100%"}
          justifyContent={"space-between"}
          pos={"relative"}
        >
          <>
            {(ayahLoad || isBuffering) && <Spinner position={"absolute"} />}
            <ReactPlayer
              url={audioUrl}
              playing={true}
              controls={true}
              height={"100%"}
              width={"100%"}
              onEnded={() => setAudioUrl("")}
              onBuffer={() => setIsBuffering(true)}
              onBufferEnd={() => setIsBuffering(false)}
            />
          </>

          <HStack h={"full"} gap={[2, 4]}>
            <Button
              variant="outline"
              h={"full"}
              disabled={currentPage >= TOTAL_PAGES}
              onClick={handleNext}
              size={["sm", "md"]}
            >
              {"<"}
            </Button>

            <Box>
              <NumberInput
                h={"full"}
                w={"full"}
                value={currentPage}
                size={["sm", "md"]}
                // fontSize={["xs", "sm", "md"]}
                onChange={(_, v) => {
                  if (v >= TOTAL_PAGES) {
                    dispatch(setCurrentPage(TOTAL_PAGES));
                  } else dispatch(setCurrentPage(v ? v : 1));
                }}
              >
                <NumberInputField
                  fontSize={["xs", "sm", "md"]}
                  // bgColor={"red"}
                  _hover={{
                    borderColor: "primary.300",
                  }}
                  _focus={{
                    borderColor: "primary.300",
                  }}
                  textAlign={"center"}
                  borderRadius={"xl"}
                />
              </NumberInput>
            </Box>

            <Button
              variant="outline"
              h={"full"}
              disabled={currentPage <= 1}
              onClick={handlePrevious}
              size={["sm", "md"]}
            >
              {">"}
            </Button>
          </HStack>
        </HStack>
      </Stack>
    </Stack>
  );
};

export default Dashboard;

const ClickableImage: React.FC<ImageProps> = ({ ...props }) => {
  return (
    <Image
      {...props}
      // boxSize="50px"
      boxSize={["40px", "50px"]} // Adjust icon size
      objectFit="contain"
      cursor={"pointer"}
      _hover={{ opacity: 0.5 }}
      _active={{ opacity: 0 }}
    />
  );
};

const NotesModal: React.FC<{
  trigger: ReactNode;
  onSave: (res: any) => void;
}> = ({ trigger, onSave }) => {
  const translation = useTranslation();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [noteVal, setValue] = useState("");

  return (
    <>
      <TouchableOpacity onClick={onOpen}>{trigger}</TouchableOpacity>

      <Modal isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false}>
        <ModalOverlay backdropFilter="blur(5px)" />
        <ModalContent bgColor={"secondary.300"}>
          <ModalHeader>
            <HStack>
              <svg
                id="edit"
                xmlns="http://www.w3.org/2000/svg"
                width="44"
                height="46"
                viewBox="0 0 44 46"
              >
                <g id="vuesax_outline_edit" data-name="vuesax/outline/edit">
                  <g id="edit-2" data-name="edit">
                    <path
                      id="Vector"
                      d="M14.208,41.208C4.253,41.208,0,36.762,0,26.354v-11.5C0,4.447,4.253,0,14.208,0h3.667A1.418,1.418,0,0,1,19.25,1.438a1.418,1.418,0,0,1-1.375,1.438H14.208C5.757,2.875,2.75,6.018,2.75,14.854v11.5c0,8.836,3.007,11.979,11.458,11.979h11c8.452,0,11.458-3.143,11.458-11.979V22.521a1.376,1.376,0,1,1,2.75,0v3.833c0,10.407-4.253,14.854-14.208,14.854Z"
                      transform="translate(2.292 2.396)"
                      fill="#bf8d46"
                    />
                    <path
                      id="Vector-2"
                      data-name="Vector"
                      d="M4.03,31.994a4.014,4.014,0,0,1-2.9-1.189A4.449,4.449,0,0,1,.052,27.069L.841,21.3a6.725,6.725,0,0,1,1.594-3.334L16.882,2.86C18.7.962,20.548,0,22.381,0s3.684.962,5.5,2.86c1.985,2.074,2.9,4.208,2.714,6.345a8.631,8.631,0,0,1-2.714,5.137l-14.446,15.1a6.238,6.238,0,0,1-3.189,1.668l-5.519.825A2.971,2.971,0,0,1,4.03,31.994ZM22.358,2.884v0c-1.1,0-2.194.619-3.533,2.007L4.378,20A3.975,3.975,0,0,0,3.553,21.7l-.789,5.768a1.562,1.562,0,0,0,.312,1.3,1.258,1.258,0,0,0,.935.348,2.181,2.181,0,0,0,.313-.024l5.518-.823a3.615,3.615,0,0,0,1.632-.862l14.447-15.1a5.94,5.94,0,0,0,1.906-3.393c.11-1.244-.513-2.567-1.906-4.043-1.279-1.338-2.445-1.988-3.562-1.988Z"
                      transform="translate(11.552 1.912)"
                      fill="#bf8d46"
                    />
                    <path
                      id="Vector-3"
                      data-name="Vector"
                      d="M10.06,12.3A14.9,14.9,0,0,1,.05,1.835,1.466,1.466,0,0,1,1,.053a1.359,1.359,0,0,1,1.687,1,12.059,12.059,0,0,0,8.1,8.472,1.457,1.457,0,0,1,.953,1.782,1.36,1.36,0,0,1-1.32,1.054A1.135,1.135,0,0,1,10.06,12.3Z"
                      transform="translate(25.964 6.483)"
                      fill="#bf8d46"
                    />
                    <path
                      id="Vector-4"
                      data-name="Vector"
                      d="M44,0V46H0V0Z"
                      fill="#bf8d46"
                      opacity="0"
                    />
                  </g>
                </g>
              </svg>
              <Heading size={"lg"}>{translation["addNote"]}</Heading>
            </HStack>
          </ModalHeader>
          <ModalBody pb={6}>
            <FormControl>
              <FormLabel>{translation["notes"]}</FormLabel>
              <Input
                placeholder={translation["type_here"]}
                _placeholder={{ color: "gray" }}
                onChange={(val) => setValue(val.target.value)}
                value={noteVal}
              />
            </FormControl>
          </ModalBody>

          <ModalFooter gap={5}>
            <Button
              colorScheme="blue"
              h={"50px"}
              onClick={() => {
                setValue("");
                onSave(noteVal);
                onClose();
              }}
            >
              {translation["save"]}
            </Button>

            <Button
              onClick={() => {
                setValue("");
                onClose();
              }}
              h={"50px"}
            >
              {translation["cancel"]}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};
